import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import ModalWrapper from 'components/Modals/ModalWrapper';
import { TextInput } from 'components/Common/Inputs/TextInput';

const editRequired = value => !value || !value.replace(/\s/g, '') || value.replace(/\s/g, '').length < 4;

class CustomerIdChangeModal extends Component {
  static propTypes = {
    reset: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    onConfirmCustomerIdChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    id: PropTypes.number,
    customerId: PropTypes.string
  };

  static defaultProps = {
    customerId: '',
    id: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      newCustomerId: '',
      confirmCustomerId: ''
    };

    this.onDataInputChange = this.onDataInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { reset, isShown } = this.props;
    if (!isShown && prevProps.isShown) {
      reset();
    }
  }

  handleCancel(e) {
    const { onCancel } = this.props;
    onCancel();
  }

  handleSubmit(event) {
    const { onConfirmCustomerIdChange, id, customerId } = this.props;
    const { newCustomerId, confirmCustomerId } = this.state;
    const updateDate = { id, newId: newCustomerId, confirmNewId: confirmCustomerId };

    event.preventDefault();

    if (!newCustomerId.replace(/\s/g, '') || newCustomerId.replace(/\s/g, '').length < 3 || newCustomerId.replace(/\s/g, '').length > 100) {
      toastr.error('', 'Please provide a Customer ID between 3 and 100 characters long.');
      return;
    }

    if ((customerId && newCustomerId && newCustomerId.replace(/\s/g, '') === customerId.replace(/\s/g, ''))) {
      toastr.error('', 'The new Customer ID cannot be the same as the current Customer ID.');
      return;
    }

    if ((!newCustomerId || !confirmCustomerId || !newCustomerId.replace(/\s/g, '') || newCustomerId.replace(/\s/g, '').length < 3 || newCustomerId !== confirmCustomerId)) {
      toastr.error('', 'The Customer ID\'s entered do not match.');
      return;
    }

    onConfirmCustomerIdChange(updateDate);
  }

  onDataInputChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  render() {
    const { isShown, customerId } = this.props;
    const {
      newCustomerId,
      confirmCustomerId
    } = this.state;

    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Change Customer ID"
        btnConfirmTitle="Confirm"
        btnCancelTitle="Cancel"
        onCancel={ this.handleCancel }
        onConfirm={ this.handleSubmit }
        formId="customerIdChangeForm"
      >
        <div>
          <form className="form" id="customerIdChangeForm" name="customerIdChangeForm" onSubmit={ this.handleSubmit }>
            <div className="form-group">
              <div className="col-12">
                <p>
                  Please provide new Customer Id for Customer <span style={ { fontWeight: 'bold' } }>{ customerId }</span>
                </p>
              </div>
            </div>

            <div className="form-group">
              <div className="col-4">
                <label
                  htmlFor="newId"
                  className="form-label m-2"
                >
                  New Customer ID
                </label>
              </div>
              <div className="col-8">
                <Field
                  id="newCustomerId"
                  name="newCustomerId"
                  component={ TextInput }
                  className="form-input m-2"
                  placeholder="Enter new customer ID"
                  required
                  value={ newCustomerId }
                  validate={ editRequired }
                  onChange={ this.onDataInputChange }
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-4">
                <label
                  htmlFor="confirmCustomerId"
                  className="form-label m-2"
                >
                  Confirm Customer ID
                </label>
              </div>
              <div className="col-8">
                <Field
                  id="confirmCustomerId"
                  name="confirmCustomerId"
                  component={ TextInput }
                  className="form-input m-2"
                  placeholder="Confirm new customer ID"
                  required
                  value={ confirmCustomerId }
                  validate={ editRequired }
                  onChange={ this.onDataInputChange }
                />
              </div>
            </div>
          </form>
        </div>
      </ModalWrapper>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      settings: {
        selectedClient
      }
    },
  } = state;

  return {
    selectedClient,
    initialValues: {
      clientId: selectedClient != null ? selectedClient.key.toString() : ''
    }
  };
}

export default connect(
  mapStateToProps
)(reduxForm({
  form: 'customerIdChangeForm'
})(CustomerIdChangeModal));
